<template>
    <div>
        <component
            :is="egg.component"
            v-for="egg in easterEggs"
            :key="egg.id"
        />
    </div>
</template>

<script>
import ConfettiMachine from "./ConfettiMachine"
import SnowGenerator from "./SnowGenerator"

export default {
    computed: {
        easterEggs() {
            return [
                { id: 1, component: SnowGenerator },
                { id: 2, component: ConfettiMachine },
            ]
        },
    },

    components: {
        ConfettiMachine,
        SnowGenerator,
    },
}
</script>
